import { useContext, useEffect } from 'react'
import { useLocalStorage } from 'react-use'
import { CopilotUploadPreset } from '../../../../../shared/types/copilot'
import { CopilotApiContext } from './contexts/api'

type Props = {
    presets: CopilotUploadPreset[]
}

const CopilotStorage = ({ presets }: Props) => {
    const { importPresetsById } = useContext(CopilotApiContext)
    const [storedPresetIds, setStoredPresetIds] = useLocalStorage('copilot-upload-presets', '')

    useEffect(() => {
        const ids = (storedPresetIds || '')
            .split(',')
            .map((id) => id.trim())
            .filter((id) => id.length)

        if (ids.length > 0) {
            importPresetsById(ids, true)
        }
    }, [])

    useEffect(() => {
        const ids = presets.map((p) => p.id)

        if (ids.length) {
            setStoredPresetIds(ids.join(','))
        }
    }, [presets])

    return null
}

export default CopilotStorage
